module.exports = __webpack_public_path__ + "static/media/E-flat-Triads.20ae67ca.png";